export default __webpack_public_path__ + "static/media/aug.8f2512bd.svg";